import '../hero/Hero.css'

const Hero = () =>{
    return(
            <div className="container hero-title">
            <p>Nature</p>
            <p>Photography</p>
            <p>Relaxation</p>
            <p>Vacation</p>
            <p>Travel</p>
            <p>Adventure</p>
        </div>
    )
}

export default Hero